// javascript
import React, { useState, useMemo, useEffect } from "react";
import { Button, Col, Form, Row, Pagination } from "react-bootstrap";
import { formatDataIt } from "../../../Utils/DateFormat";

const CommentsComponent = ({ comments = [], setNewComment, handleSumbit }) => {
    const pageSize = 5;
    const [currentPage, setCurrentPage] = useState(1);

    const totalComments = comments.length;
    const totalPages = Math.max(1, Math.ceil(totalComments / pageSize));

    useEffect(() => {
        if (currentPage > totalPages) setCurrentPage(totalPages);
    }, [totalPages, currentPage]);

    const paginatedComments = useMemo(() => {
        const start = (currentPage - 1) * pageSize;
        return comments.slice(start, start + pageSize);
    }, [comments, currentPage]);

    const goToPage = (n) => {
        if (n >= 1 && n <= totalPages) setCurrentPage(n);
    };

    const renderPagination = () => {
        if (totalPages <= 1) return null;

        const range = 2;
        const start = Math.max(1, currentPage - range);
        const end = Math.min(totalPages, currentPage + range);
        const items = [];

        if (start > 1) {
            items.push(
                <Pagination.Item key={1} onClick={() => goToPage(1)}>
                    <span style={1 === currentPage ? { color: "#fff" } : undefined}>1</span>
                </Pagination.Item>
            );
            if (start > 2) items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
        }

        for (let p = start; p <= end; p++) {
            items.push(
                <Pagination.Item key={p} active={p === currentPage} onClick={() => goToPage(p)}>
                    <span style={p === currentPage ? { color: "#fff" } : undefined}>{p}</span>
                </Pagination.Item>
            );
        }

        if (end < totalPages) {
            if (end < totalPages - 1) items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
            items.push(
                <Pagination.Item key={totalPages} onClick={() => goToPage(totalPages)}>
                    <span style={totalPages === currentPage ? { color: "#fff" } : undefined}>{totalPages}</span>
                </Pagination.Item>
            );
        }

        return (
            <Pagination className="mt-2">
                <Pagination.Prev onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1} />
                {items}
                <Pagination.Next onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages} />
            </Pagination>
        );
    };

    return (
        <Row>
            {comments && comments.length > 0 ? (
                <>
                    <Col md={6}>
                        <h4 className="mb-3 text-start">Lista Commenti ({totalComments})</h4>
                    </Col>

                    {paginatedComments.map((i) => (
                        <Col key={i.id} md={12} className="text-start border-bottom border-light mt-2">
                            <p className="mb-0 mt-2">💬 {i.comment}</p>
                            <p className="text-smaller text-muted">
                                Inviato da {i.user ? i.user : "N/A"} il {formatDataIt(new Date(i.created_at))}
                            </p>
                        </Col>
                    ))}

                    <Col md={12} className="mt-2 text-end">
                        {renderPagination()}
                    </Col>
                </>
            ) : (
                <p className="text-muted">Nessun commento ancora.</p>
            )}

            <Col md={12} className="mt-3">
                <h5>Aggiungi un commento</h5>
                <Form.Control as="textarea" rows={3} onChange={(e) => setNewComment(e.currentTarget.value)} placeholder="Scrivi un commento..." />
                <Button className="mt-2" onClick={handleSumbit}>
                    Invia
                </Button>
            </Col>
        </Row>
    );
};

export default CommentsComponent;
